// EditClass.tsx
import React, { useEffect } from 'react';
import { Form, Input, Button, Space } from 'antd';
import { putRequest, ResponseDataType } from 'api';
import { toast } from 'react-toastify';

export interface ClassDataType {
  classId: number;
  className: string;
  classLevel: string;
  classOrder: number;
  description: string | null;
}

interface Props {
  classData: ClassDataType;
  schoolId: number;
  onSuccess: () => void;
  onClose: () => void;
}

export const EditClass: React.FC<Props> = ({
  classData,
  schoolId,
  onSuccess,
  onClose,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (classData) {
      form.setFieldsValue({
        className: classData.className,
        classLevel: classData.classLevel,
        classOrder: classData.classOrder,
        description: classData.description,
      });
    }
  }, [classData, form]);

  const handleUpdate = async (values: any) => {
    const formData = {
      ...values,
      className: values.className?.trim(),
      classLevel: values.classLevel?.trim(),
      classId: classData.classId,
      schoolId: schoolId,
    };

    const response: ResponseDataType<any> = await putRequest(
      '/cms/class/update-class',
      formData,
      'json'
    );

    if (response?.code === 200) {
      toast.success('Cập nhật lớp học thành công!');
      onSuccess();
      onClose();
    } else {
      toast.error(response?.msg || 'Cập nhật lớp học thất bại!');
    }
  };

  return (
    <Form form={form} onFinish={handleUpdate} layout="vertical">
      <Form.Item
        name="classLevel"
        label="Khối"
        rules={[{ required: true, message: 'Vui lòng nhập khối' }]}
      >
        <Input placeholder="Nhập khối" />
      </Form.Item>
      <Form.Item
        name="className"
        label="Tên lớp"
        rules={[{ required: true, message: 'Vui lòng nhập tên lớp' }]}
      >
        <Input placeholder="Nhập tên lớp" />
      </Form.Item>
      <Form.Item name="classOrder" label="Thứ tự lớp">
        <Input placeholder="Nhập thứ tự lớp" />
      </Form.Item>
      <Form.Item name="description" label="Ghi chú">
        <Input.TextArea rows={3} placeholder="Nhập mô tả / ghi chú lớp học" />
      </Form.Item>
      <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
        <Space>
          <Button onClick={onClose}>Hủy</Button>
          <Button type="primary" htmlType="submit">
            Lưu thay đổi
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
